exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".banner{height:180px;padding:0;list-style:none;margin:20px 0;position:relative;overflow:hidden;text-align:center}.banner__setting{position:absolute;top:10px;right:10px;color:#ccc;font-size:18px;z-index:1}.banner__link{height:150px;position:absolute;display:inline-block;left:0;top:0;right:0;bottom:0}.image-gallery-content{height:180px;overflow:hidden}.image-gallery-content img{width:855pt;height:180px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/containers/App/screens/Tube/screens/Index/components/banner/style.css
 ** module id = 2733
 ** module chunks = 72
 **/